import React, { Component } from "react";
import Header from "../../ui/header/header";
import { Title, Paragraph } from "../../ui/typography/typography";
import "../../ui/base/base.css";
import styles from "./error404Page.css";
import { PrimaryLinkButton } from "../../ui/button/button";

class Error404Page extends Component {
	render() {
		return (
			<div>
				<Header history={this.props.history} />
				<div className={styles.grid}>
					<Title>404!</Title>
					<Paragraph>
						Sorry, but the page you're looking for was either not found or
						doesn't exist. Try a search above or return home…
					</Paragraph>

					<PrimaryLinkButton to="/">Return home</PrimaryLinkButton>
				</div>
			</div>
		);
	}
}

export default Error404Page;



// WEBPACK FOOTER //
// ./src/components/pages/error404Page/error404Page.js